import React, { useEffect } from 'react';
import '../stylesheet/PageLoader.css';

// Shared "content is loading" indicator for pages waiting on Firebase
// data. Themed around the site being a career portfolio: a small runner
// figure advances up a dashed path towards a flag, looping endlessly
// while the real content streams in.
const PageLoader = () => {
    // Footer/Copyright are rendered once in App.jsx with no idea whether
    // the current page's Firebase data has actually arrived yet - showing
    // the social-links footer floating above an empty, still-loading page
    // looked broken. Mark <body> while this is mounted so Footer.css can
    // hide itself for that window; unmount removes the mark again.
    useEffect(() => {
        document.body.classList.add('is-page-loading');
        return () => {
            document.body.classList.remove('is-page-loading');
        };
    }, []);

    return (
    <div className="page-loader" role="status" aria-label="Loading">
        <svg className="page-loader-track" viewBox="0 0 220 110" xmlns="http://www.w3.org/2000/svg">
            <path
                className="page-loader-path"
                d="M14 92 C 70 92, 120 40, 204 22"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeDasharray="1 12"
            />
            <g className="page-loader-flag">
                <line x1="204" y1="22" x2="204" y2="4" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                <path d="M204 5 L216 9 L204 13 Z" fill="currentColor" />
            </g>
            <g className="page-loader-runner">
                <circle className="page-loader-head" cx="0" cy="-14" r="4.5" fill="currentColor" />
                <line className="page-loader-torso" x1="0" y1="-9" x2="0" y2="2" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                <line className="page-loader-arm-back" x1="0" y1="-6" x2="-6" y2="-1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <line className="page-loader-arm-front" x1="0" y1="-6" x2="6" y2="1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <line className="page-loader-leg-back" x1="0" y1="2" x2="-6" y2="10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                <line className="page-loader-leg-front" x1="0" y1="2" x2="6" y2="10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
            </g>
        </svg>
        <p className="page-loader-caption">
            Loading
            <span className="page-loader-dots">
                <span>.</span><span>.</span><span>.</span>
            </span>
        </p>
    </div>
    );
};

export default PageLoader;
